import {twMerge} from '@sdox/utils'

import {LazyImage} from '../LazyImage'

import type {LazyImageProps} from '../LazyImage'

const avatarSizes = {
  mini: 'h-8 w-8',
  small: 'h-12 w-12',
  medium: 'h-16 w-16',
  large: 'h-24 w-24',
  full: 'h-full aspect-1',
}

export interface AvatarProps extends LazyImageProps {
  src?: string
  size?: 'mini' | 'small' | 'medium' | 'large' | 'full'
}

export const Avatar = ({className, src, size = 'medium', ...restProps}: AvatarProps) => (
  <LazyImage
    className={twMerge('inline-block rounded-full', avatarSizes[size], className)}
    src={src}
    alt={'avatar'}
    logError={false}
    {...restProps}
  />
)
